// import components below
import PageHeaderUI from 'components/UI/PageHeaderUI';

// main component
const AdmissionHeader = (props) => {
  const { active } = props;

  return (
    <div className='admissionHeader'>
      <PageHeaderUI>
        <h4>Admission Module</h4>
        <p>Dashboard / Admission / {active}</p>
      </PageHeaderUI>
    </div>
  );
};

export default AdmissionHeader;
